import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"

import { Sharer } from "./Sharer"

import styles from "./SharersList.module.scss"
import { usePolyglot } from "src/contexts"

interface Props {
  follows: Follow[];
}

export function SharersList(props: Props) {
  const polyglot = usePolyglot()

  const { follows } = props

  return (
    <div
      className={styles.listContainer}
      id="sharers-list"
    >
      <div className={styles.listTitle}>
        {polyglot.t("pages.data_sharing.following.people_following_title")}
      </div>
      {follows.map((follow) => (
        <Sharer
          key={follow.id}
          follow={follow}
        />
      ))}
    </div>
  )
}
